import React, { useEffect, useMemo, useState } from "react";
import { Collapse, Table } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import CardPage from "../../../layout/CardPage";

export const SemaforoVisor = ({
  titulo,
  columns,
  data,
  loading,
  rowKey = "asistenciaID",
  groupBy,
  defaultGroupLabel,
  expandedRowRender,
  pageSize = 5,
  activeKey,
  onPanelChange,
}) => {
  const grupos = useMemo(() => {
    const map = {};
    data.forEach((item) => {
      const key = item[groupBy] || defaultGroupLabel;
      if (!map[key]) map[key] = [];
      map[key].push(item);
    });
    return map;
  }, [data, groupBy, defaultGroupLabel]);

  const expandable = expandedRowRender
    ? {
        expandedRowRender,
        expandIcon: ({ expanded, onExpand, record }) => (
          <span
            onClick={(e) => onExpand(record, e)}
            style={{ cursor: "pointer", fontSize: 14 }}
          >
            {expanded ? <MinusOutlined /> : <PlusOutlined />}
          </span>
        ),
      }
    : undefined;

  const [currentPageSize, setCurrentPageSize] = useState(pageSize);

  useEffect(() => {
    setCurrentPageSize(pageSize);
  }, [pageSize]);

  const paginationConfig = {
    position: ["bottomCenter"],
    pageSize: currentPageSize,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50"],
    onShowSizeChange: (_, size) => setCurrentPageSize(size),
  };

  return (
    <CardPage titulo={titulo}>
      <Collapse activeKey={activeKey || []} onChange={onPanelChange}>
        {Object.entries(grupos).map(([usuario, items]) => (
          <Collapse.Panel key={usuario} header={`${usuario} (${items.length})`}>
            <Table
              columns={columns}
              dataSource={items}
              rowKey={rowKey}
              loading={loading}
              pagination={paginationConfig}
              size="small"
              expandable={expandable}
            />
          </Collapse.Panel>
        ))}
      </Collapse>
    </CardPage>
  );
};
